export const environment = {
  firebase: {
    projectId: 'steddie-d5171',
    appId: '1:974402931258:web:d9efcf53853275b14c8303',
    storageBucket: 'steddie-d5171.appspot.com',
    locationId: 'europe-west3',
    apiKey: 'AIzaSyCAl0eyLQ6HK3z-JpYXkKIDNHtHcRgLue4',
    authDomain: 'steddie-d5171.firebaseapp.com',
    messagingSenderId: '974402931258',
    measurementId: "G-YMGNK2DTXD",
  },
  googleApiKey: 'AIzaSyCAl0eyLQ6HK3z-JpYXkKIDNHtHcRgLue4',
  production: true
};
